// ─── Data ────────────────────────────────────────────────────────────────────
export const CARDS = [
  [
    "Velocity-grade infrastructure",
    "AI-powered decision engine",
    "Real-time market signals",
    "Zero-latency data pipeline",
  ],
  [
    "Digital Transformation & Platforms | End-to-end digital transformation, custom software, and scalable business systems",
    "AI, Data & Intelligence | AI solutions, predictive analytics, and data engineering for smarter decisions",
    "Automation & Business Systems | Workflow automation, CRM/ERP solutions, and process optimization systems",
    "Cloud, Security & Infrastructure | Cloud infrastructure, DevOps, cybersecurity, and high-performance architecture",
  ],
  [
    "Talent & Hiring | Talent sourcing, recruitment, and candidate management solutions",
    "HR & People Operations | End-to-end HR services, compliance, and workforce management",
    "Contract Workforce | Skilled contract manpower and workforce augmentation services",
    "Workspace & Office Setup | Office setup, infrastructure provisioning, and workspace aggregation solutions",
  ],
  [
    "Brand & Strategy | Brand strategy, positioning, and integrated marketing systems",
    "Lead Generation & Growth | Lead generation, funnels, and conversion optimization systems",
    "Digital & Performance Marketing | Digital marketing, social media, and performance marketing campaigns",
    "Content & Creative Strategy | Storytelling, creative direction, and content systems that build audience engagement",
  ],
  [
    "Vehicle Care | Precision exterior and interior care in residential ecosystem",
    "EV Infrastructure | Integrated EV charging within residential ecosystems",
    "Smart Access | App-based scheduling and seamless service access",
    "Extended Care | On-demand servicing and certified vehicle support",
  ],
  [
    "PropTech valuation engine",
    "Smart portfolio analytics",
    "Location intelligence data",
    "Asset lifecycle management",
  ],
  [
    "Frictionless travel booking",
    "Personalised itinerary AI",
    "Loyalty rewards engine",
    "Multi-modal route planner",
  ],
  [
    "Venture signal detection",
    "Startup growth analytics",
    "Founder network mapping",
    "Early-stage deal flow",
  ],
];

/* 
these are connected to READ MORE , PLANET IMAGE , PLANET NAME(DATA) , TAGS AND STYLES
*/

const PUBLIC_URL = process.env.PUBLIC_URL || "";

export const SOLAR = [
  { id: "mercury", label: "Planet", name: "HOGC Enterprises", tag: "Built as individual worlds. Connected as one universe.", url: "/", texUrl: `${PUBLIC_URL}/textures/mercury.jpg`, glow: "rgba(200,158,118,.42)", speed: "30s", bs: "0 0 65px rgba(188,143,127,.55)", au: "0.39 AU" },
  { id: "venus", label: "Planet", name: "GC Tech", tag: "Where technology meets business evolution.", url: "https://gctech.hogc.in/", texUrl: `${PUBLIC_URL}/textures/venus.jpg`, glow: "rgba(255,195,80,.40)", speed: "36s", bs: "0 0 65px rgba(200,130,20,.60)", au: "0.723 AU" },
  { id: "earth", label: "Planet", name: "SapienSync", tag: "Powering businesses with people and infrastructure.", url: "https://sapiensync.hogc.in/", texUrl: `${PUBLIC_URL}/textures/earth.jpg`, glow: "rgba(100,160,255,.42)", speed: "20s", bs: "0 0 65px rgba(100,150,255,.60)", au: "1 AU" },
  { id: "mars", label: "Planet", name: "GC Marketing", tag: "Where businesses become brands.", url: "https://nimble-paprenjak-692e82.netlify.app/", texUrl: `${PUBLIC_URL}/textures/mars.jpg`, glow: "rgba(220,75,35,.42)", speed: "26s", bs: "0 0 65px rgba(200,75,35,.60)", au: "1.524 AU" },
  { id: "jupiter", label: "Planet", name: "Autotown", tag: "Architects of intelligent mobility.", url: "https://charming-genie-25f447.netlify.app/", texUrl: `${PUBLIC_URL}/textures/jupiter.jpg`, glow: "rgba(210,165,90,.40)", speed: "12s", bs: "0 0 65px rgba(200,148,75,.55)", au: "5.203 AU" },
  { id: "connect", label: "", name: "Connect", tag: "Let's start a conversation.", url: "", texUrl: null, glow: "rgba(254,160,130,.25)", speed: null, bs: null, au: "\u221e" },
];
